<page-heading
  [title]="'report.listContact.pageTitle' | translate"
  [description]="'report.listContact.pageDescription' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="reportForm">
          <div class="row g-2 d-flex justify-content-end">
            <div
              class="col-xs-12 col-lg-3 trend-datepicker"
              [matTooltip]="'report.listContact.previousPeriod' | translate"
            >
              <mat-date-range-input
                [rangePicker]="pickerPrevious"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.listContact.previousPeriod' | translate"
                  formControlName="dateStartPrevious"
                />
                <input
                  matEndDate
                  [placeholder]="'report.listContact.endDate' | translate"
                  formControlName="dateEndPrevious"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="pickerPrevious" />
              <mat-date-range-picker
                #pickerPrevious
                (selectionChange)="onPeriodChangePrevious($event)"
              >
                <mat-datepicker-actions>
                  <mat-form-field>
                    <mat-label>{{ 'report.listContact.select' | translate }}</mat-label>
                    <mat-select
                      (selectionChange)="onPeriodChangePrevious($event)"
                    >
                      <mat-option value="1">{{ 'report.listContact.today' | translate }}</mat-option>
                      <mat-option value="7">{{ 'report.listContact.last7Days' | translate }}</mat-option>
                      <mat-option value="15">{{ 'report.listContact.last15Days' | translate }}</mat-option>
                      <mat-option value="30">{{ 'report.listContact.last30Days' | translate }}</mat-option>
                      <mat-option value="60">{{ 'report.listContact.last60Days' | translate }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    {{ 'report.listContact.ok' | translate }}
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>

            <div
              class="col-xs-12 col-lg-3 trend-datepicker"
              [matTooltip]="'report.listContact.currentPeriod' | translate"
            >
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.listContact.currentPeriod' | translate"
                  formControlName="dateStartPrevious"
                />
                <input
                  matEndDate
                  [placeholder]="'report.listContact.endDate' | translate"
                  formControlName="dateEndPrevious"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker
                #picker
                (selectionChange)="onPeriodChangePrevious($event)"
              >
                <mat-datepicker-actions>
                  <mat-form-field>
                    <mat-label>{{ 'report.listContact.select' | translate }}</mat-label>
                    <mat-select
                      (selectionChange)="onPeriodChangePrevious($event)"
                    >
                      <mat-option value="1">{{ 'report.listContact.today' | translate }}</mat-option>
                      <mat-option value="7">{{ 'report.listContact.last7Days' | translate }}</mat-option>
                      <mat-option value="15">{{ 'report.listContact.last15Days' | translate }}</mat-option>
                      <mat-option value="30">{{ 'report.listContact.last30Days' | translate }}</mat-option>
                      <mat-option value="60">{{ 'report.listContact.last60Days' | translate }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    {{ 'report.listContact.ok' | translate }}
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterChannel"
                type="button"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelChannel | translate }}</span>
              </button>

              <mat-menu #filterChannel="matMenu">
                <button mat-menu-item (click)="selectChannel(-1, 'report.listContact.all')">
                  {{ 'report.listContact.all' | translate }}
                </button>

                @if (channelAttendant) { @for (channel of channelAttendant;
                track $index) {
                <button
                  mat-menu-item
                  (click)="selectChannel($safeNavigationMigration(channel?._id), $safeNavigationMigration(channel?.name))"
                >
                  {{ channel?.name }}
                </button>
                } }
              </mat-menu>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterDepartmentAtt"
                type="button"
                class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
              >
                <span>{{ labelDepartment | translate }}</span>
              </button>

              <mat-menu
                #filterDepartmentAtt="matMenu"
                class="custom-menu-panel"
              >
                <button mat-menu-item (click)="selectDepartment(-1, 'report.listContact.all')">
                  {{ 'report.listContact.all' | translate }}
                </button>

                @if (department?.length) { @for (dept of department; track
                dept?._id) {
                <button
                  mat-menu-item
                  (click)="selectDepartment($safeNavigationMigration(dept?._id), $safeNavigationMigration(dept?.name))"
                >
                  {{ dept?.name }}
                </button>
                } }
              </mat-menu>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterUserAdm"
                type="button"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelAttendant | translate }}</span>
              </button>

              <mat-menu #filterUserAdm="matMenu" class="custom-menu-panel">
                <button mat-menu-item (click)="selectAttendant(-1, 'report.listContact.all')">
                  {{ 'report.listContact.all' | translate }}
                </button>

                @if (userAttendant?.length) { @for (user of userAttendant; track
                user?._id) {
                <button
                  mat-menu-item
                  (click)="selectAttendant($safeNavigationMigration(user?._id), $safeNavigationMigration(user?.name))"
                >
                  {{ user?.name }}
                </button>
                } }
              </mat-menu>
            </div>

            <div
              class="col-xs-6 col-md-6 col-lg-1 gap-2 btn-group trend-button"
            >
              <button
                class="btn btn-primary fw-bold"
                [matTooltip]="'report.listContact.export' | translate"
                (click)="exportFile()"
              >
                <i class="ri-share-box-fill"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

@if (!loadingContent) {
<div class="card-body mb-3">
  <div class="d-flex flex-wrap gap-2">
    <div
      class="flex-fill card-hover"
      (click)="
        openModalCountContact('channel', $safeNavigationMigration(countItemsContact?.totalChannelIds))
      "
    >
      <card-graphic-small-component
        [label]="'report.listContact.channels' | translate"
        [total]="countItemsContact?.totalChannels.toString() ?? '0'"
      />
    </div>
    <div
      class="flex-fill card-hover"
      (click)="
        openModalCountContact(
          'department',
          $safeNavigationMigration(countItemsContact?.totalDepartmentIds)
        )
      "
    >
      <card-graphic-small-component
        [label]="'report.listContact.departments' | translate"
        [total]="countItemsContact?.totalDepartments.toString() ?? '0'"
      />
    </div>
    <div
      class="flex-fill card-hover"
      (click)="openModalCountContact('user', $safeNavigationMigration(countItemsContact?.totalUserIds))"
    >
      <card-graphic-small-component
        [label]="'report.listContact.attendants' | translate"
        [total]="countItemsContact?.totalUsers.toString() ?? '0'"
      />
    </div>
    <div
      class="flex-fill card-hover"
      (click)="openModalCountContact('leadPrevious')"
    >
      <card-graphic-small-component
        [label]="'report.listContact.previousPeriodCard' | translate"
        [total]="countItemsContact?.totalContactPrevious.toString() ?? '0'"
      />
    </div>
    <div
      class="flex-fill card-hover"
      (click)="openModalCountContact('leadCurrent')"
    >
      <card-graphic-small-component
        [label]="'report.listContact.currentPeriodCard' | translate"
        [total]="countItemsContact?.totalContactCurrent.toString() ?? '0'"
      />
    </div>
  </div>
</div>

<div class="card mb-3">
  <div class="card-body">
    <div class="row g-2 d-flex justify-content-center mb-3">
      <div class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button">
        <button
          [matMenuTriggerFor]="menuGraphic"
          type="button"
          class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
        >
          <span>{{ selectedGraphicLabel | translate }}</span>
        </button>

        <mat-menu #menuGraphic="matMenu">
          @for (type of typeCharts; track $index) {
          <button
            mat-menu-item
            [value]="type.value"
            (click)="onGraphicSelect(type.value, $safeNavigationMigration(type?.name))"
          >
            {{ $safeNavigationMigration(type?.name) | translate }}
          </button>
          }
        </mat-menu>
      </div>
      <div class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button">
        <button
          [matMenuTriggerFor]="menuList"
          type="button"
          class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
        >
          <span>{{ selectedListLabel | translate }}</span>
        </button>

        <mat-menu #menuList="matMenu">
          @for (type of typeCharts; track $index) {
          <button
            mat-menu-item
            [value]="type.value"
            (click)="onListSelect(type.value, $safeNavigationMigration(type?.name))"
          >
            {{ $safeNavigationMigration(type?.name) | translate }}
          </button>
          }
        </mat-menu>
      </div>
    </div>

    <div class="row g-2">
      <div class="col-xs-12 col-lg-6 border-end">
        @switch (selectedGraphic) { @case ('channel') {
        <div class="flex-fill">
          <ngx-charts-bar-horizontal
            [results]="graphicChannel"
            [xAxis]="true"
            [yAxis]="true"
            [showXAxisLabel]="true"
            [showYAxisLabel]="true"
            [scheme]="colorScheme"
            [autoResize]="true"
          />
        </div>
        } @case ('user') {
        <div class="flex-fill">
          <ngx-charts-bar-horizontal
            [results]="graphicUser"
            [xAxis]="true"
            [yAxis]="true"
            [showXAxisLabel]="true"
            [showYAxisLabel]="true"
            [scheme]="colorScheme"
            [autoResize]="true"
          />
        </div>
        } @case ('user') {
        <div class="flex-fill">
          <ngx-charts-bar-horizontal
            [results]="graphicUser"
            [xAxis]="true"
            [yAxis]="true"
            [showXAxisLabel]="true"
            [showYAxisLabel]="true"
            [scheme]="colorScheme"
            [autoResize]="true"
          />
        </div>
        } @case('department') {
        <ngx-charts-bar-horizontal
          [results]="graphicDepartment"
          [xAxis]="true"
          [yAxis]="true"
          [showXAxisLabel]="true"
          [showYAxisLabel]="true"
          [scheme]="colorScheme"
          [autoResize]="true"
        />
        } @default {
        <div class="alert alert-secondary mb-0">
          {{ 'report.listContact.selectGraphicToDisplay' | translate }}
        </div>
        } }
      </div>
      <div class="col-xs-12 col-lg-6 p-4">
        @switch (selectedList) { @case ('channel') {
        <table class="table table-sm w-100 align-middle table-divide">
          <thead class="bg-light"></thead>
          <tbody class="bg-white">
            @for (item of graphicChannel; track item) {
            <tr>
              <td class="text-nowrap px-3 py-3 small text-muted">
                <p class="mb-0">{{ item?.name }}</p>
              </td>
              <td class="px-3 py-3 small">
                <p class="mb-0">{{ item?.value }}</p>
              </td>
            </tr>
            }
            <tr></tr>
          </tbody>
        </table>
        } @case ('user') {
        <table class="table table-sm w-100 align-middle table-divide">
          <thead class="bg-light"></thead>
          <tbody class="bg-white">
            @for (item of graphicUser; track item) {
            <tr>
              <td class="text-nowrap px-3 py-3 small text-muted">
                <p class="mb-0">{{ item?.name }}</p>
              </td>
              <td class="px-3 py-3 small">
                <p class="mb-0">{{ item?.value }}</p>
              </td>
            </tr>
            }
            <tr></tr>
          </tbody>
        </table>
        } @case ('department') {
        <table class="table table-sm w-100 align-middle table-divide">
          <thead class="bg-light"></thead>
          <tbody class="bg-white">
            @for (item of graphicDepartment; track item) {
            <tr>
              <td class="text-nowrap px-3 py-3 small text-muted">
                <p class="mb-0">{{ item?.name }}</p>
              </td>
              <td class="px-3 py-3 small">
                <p class="mb-0">{{ item?.value }}</p>
              </td>
            </tr>
            }
            <tr></tr>
          </tbody>
        </table>
        } @default {
        <div class="alert alert-secondary mb-0">
          {{ 'report.listContact.selectListToDisplay' | translate }}
        </div>
        } }
      </div>
    </div>
  </div>
</div>
}

<div class="card">
  @if (loadingContent) {
  <content-loading-list />
  } @if (!loadingContent && pager.total === 0) {
  <empty-records-component
    [message]="'report.listContact.noRecordsFound' | translate"
    [subMessage]="'report.listContact.changeFilterToSearch' | translate"
    [icon]="'mdi mdi-alert-circle-outline'"
  />
  } @if (!loadingContent && pager.total > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'report.listContact.channelColumn' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.listContact.departmentColumn' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.listContact.attendantColumn' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.listContact.attendancePreviousPeriod' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.listContact.attendanceCurrentPeriod' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for(item of pager.list; track item) {
        <tr>
          <td>
            <span>
              {{ item?.channel }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.department }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.user }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.totalContactPrevious }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.totalContactCurrent }}
            </span>
          </td>
        </tr>
        }
      </tbody>
    </table>
    @if (pager.total > pager.perPage) {
    <paginator [pager]="pager" (onPager)="loadPage($event)"></paginator>
    }
  </div>
  }
</div>
